import { styled } from 'styled-components';
import React, { FC, PropsWithChildren } from 'react';
import { Box } from '@idk-web/core-ui';
import { Language } from '@idk-web/api';
import Header from '@/components/inbox/header/Header';
import Footer from '@/components/inbox/footer/Footer';

const Container = styled(Box).attrs({
  direction: 'vertical',
})`
  min-height: 100vh;
`;

const Main = styled.main`
  position: relative;
  display: flex;
  flex-grow: 1;
  background-color: ${({ theme }) => theme.palette.grayscale.light5};
`;

export type LayoutProps = PropsWithChildren<{
  logo?: string;
  languages?: Language[];
}>;

const Layout: FC<LayoutProps> = ({ logo, languages, children }) => {
  return (
    <Container>
      <Header logo={logo} languages={languages} />
      <Main>{children}</Main>
      <Footer />
    </Container>
  );
};

export default Layout;
